// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import 'promise-polyfill/src/polyfill';
import VueMeta from 'vue-meta';
import VueGtag from "vue-gtag";

// require('@/utils/jplugins');
require('@/utils/utilities');
require('lightbox2');


Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

if (window.GATrackingID) {
    Vue.use(
      VueGtag, {
        config: { id: window.GATrackingID },
      },
      router
    )
  }

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue({});
axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};
axios.defaults.withCredentials = true;
// global._    =   _;
global.csrf =   null;
// global.NProgress = NProgress;
global.axios = axios;
global.base_url = location.hostname == 'localhost' ? 'https://staging.thinkstep-anz.com/' : '/';
global.endpoints = require('@/config/endpoints');

Vue.mixin({
  methods: {
    HandleContentedLinks: (content, me) => {
        $(content).find('a:not([data-lightbox])').each(function(e) {
            const href = $(this).attr('href') ? $(this).attr('href') : ''
            if ($(this).attr('target') != '_blank' && href.indexOf('/') == 0) {
                $(this).click(function(e) {
                    e.preventDefault();
                    if (href == '#') {
                        return
                    }

                    const hrefhash= href.split('#').length > 1 ? `#${href.split('#')[1]}` : null
                    const nakedhref = href.split('#')[0].rtrim('/')
                    const nakedpath = me.$route.path.split('#')[0].rtrim('/')
                    if (nakedhref != nakedpath) {
                        me.$router.push({ path: href })
                    } else if (hrefhash && $(hrefhash).length) {
                        $(window).scrollTop($(hrefhash).offset().top - $('#header').height() - 64);
                    } else {
                        $(window).scrollTop(0)
                    }
                })
            }
        })
    }
  }
})

new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js